var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-date-picker", {
        staticClass: "mr-2",
        attrs: {
          "value-format": "yyyy-MM-dd",
          format: "dd.MM.yyyy",
          type: "date",
          placeholder: "Выбрать день"
        },
        model: {
          value: _vm.datePreorders,
          callback: function($$v) {
            _vm.datePreorders = $$v
          },
          expression: "datePreorders"
        }
      }),
      _vm._v(" "),
      _c(
        "b-button",
        {
          staticClass: "mr-5",
          attrs: { variant: "success" },
          on: { click: _vm.printPreorders }
        },
        [_vm._v("Печать предзаказов")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-493857e3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-493857e3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PreordersPrintPicker.vue
// module id = null
// module chunks = 